import React, { useRef, useEffect } from 'react';
import styles from './add-contact-selector.module.css';
import { MyIcons } from '../../icons/my-icons';

/**
 * Modal para seleccionar el tipo de contacto a crear
 */
const AddContactSelectorModal = ({ isOpen, onClose, phoneNumber, onSelectType }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleSelectType = (type) => {
    onSelectType(type);
    onClose();
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal} ref={modalRef}>
        <div className={styles.header}>
          <h3 className={styles.title}>Añadir Contacto</h3>
          <button className={styles.closeButton} onClick={onClose}>
            <MyIcons name="close" width={24} height={24} color="black" />
          </button>
        </div>

        <div className={styles.content}>
          <p className={styles.phoneInfo}>
            <strong>Número:</strong> {phoneNumber}
          </p>
          <p className={styles.question}>¿Qué tipo de contacto deseas crear?</p>

          <div className={styles.optionsGrid}>
            <button
              className={styles.optionButton}
              onClick={() => handleSelectType('independiente')}
            >
              <MyIcons name="user" width={32} height={32} color="#007bff" />
              <span className={styles.optionLabel}>Contacto Independiente</span>
              <span className={styles.optionDescription}>Sin relación específica</span>
            </button>

            <button
              className={styles.optionButton}
              onClick={() => handleSelectType('compania')}
            >
              <span style={{ fontSize: '32px' }}>🏢</span>
              <span className={styles.optionLabel}>Compañía</span>
              <span className={styles.optionDescription}>Contacto de empresa</span>
            </button>

            <button
              className={styles.optionButton}
              onClick={() => handleSelectType('operario')}
            >
              <span style={{ fontSize: '32px' }}>👷</span>
              <span className={styles.optionLabel}>Operario</span>
              <span className={styles.optionDescription}>Trabajador/técnico</span>
            </button>

            <button
              className={styles.optionButton}
              onClick={() => handleSelectType('comercial')}
            >
              <span style={{ fontSize: '32px' }}>💼</span>
              <span className={styles.optionLabel}>Comercial</span>
              <span className={styles.optionDescription}>Representante comercial</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddContactSelectorModal;
